// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__bebas_c664d8', '__bebas_Fallback_c664d8'"},"className":"__className_c664d8","variable":"__variable_c664d8"};